module.exports = __webpack_public_path__ + "static/media/mobimagecric.5c6dc72e.jpeg";